import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import Home from './pages/Home';
import Story from './pages/Story';
import Future from './pages/Future';
import Header from './components/Header';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

function App() {
  return (
    <Router>
      <div className="App">
        <ScrollToTop />
        <Header />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/histoire" element={<Story />} />
            <Route path="/avenir" element={<Future />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;